/* MSLuxe — theme.js */
(function () {
  'use strict';

  /* ---- mobile menu drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var first = drawer.querySelector('button, a');
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---- accordions ---- */
  document.querySelectorAll('[data-accordion-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var sign = btn.querySelector('[data-sign]');
      if (sign) sign.textContent = open ? '\u2212' : '+';
    });
  });

  /* ---- quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.dataset.step, 10);
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- product gallery ---- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full;
        main.srcset = '';
        main.alt = t.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', 'false');
        });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- variant selection ---- */
  var form = document.querySelector('[data-variant-form]');
  if (form) {
    var data = document.querySelector('[data-variant-json]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idField = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

    function money(cents) {
      var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }

    function selected() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (el) {
          if (el.type === 'radio') return null;
          return el.value;
        }
      ).filter(function (v) { return v !== null; });
    }

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (el) {
        var i = parseInt(el.dataset.optionIndex, 10);
        if (el.type === 'radio') {
          if (el.checked) opts[i] = el.value;
        } else {
          opts[i] = el.value;
        }
      });
      return opts;
    }

    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idField.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<del>' + money(match.compare_at_price) + '</del><ins>' + money(match.price) + '</ins>'
          : money(match.price);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (el) {
      el.addEventListener('change', update);
    });
    update();
  }

  /* ---- live cart count ---- */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('msluxe:cart-updated', refreshCartCount);

  /* ---- scroll reveal ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { io.observe(t); });
  }
})();
